import {
  ComBoxSensorType,
  ROOM_SENSOR_INDEX,
} from "@/data/models/ComBoxSensorData";

export const COMBOX_SAMPLE_SENSOR_COLUMN_ORDER = [
  ROOM_SENSOR_INDEX,
  0,
  1,
  2,
  3,
  5,
  6,
  7,
  8,
];

export function getComBoxSampleSensorColumnKey(sensorIndex: number) {
  return sensorIndex === ROOM_SENSOR_INDEX
    ? "roomSensor"
    : `floorSensor${sensorIndex}`;
}

export function isConfiguredComBoxSampleSensor(sensorType?: ComBoxSensorType) {
  return (
    sensorType !== undefined &&
    sensorType !== ComBoxSensorType.EMPTY &&
    sensorType !== ComBoxSensorType.UNKNOWN
  );
}

export function isMeaningfulSampleSensorValue(value: unknown) {
  if (value === undefined || value === null) {
    return false;
  }

  const normalizedValue = String(value).trim().replace(/\s+/g, " ");

  return (
    normalizedValue !== "" &&
    normalizedValue !== "-" &&
    normalizedValue !== "- / -"
  );
}

export function getVisibleComBoxSampleSensorIndexes(
  sensorConfig: ComBoxSensorType[] | undefined,
  sampleRows: object[]
) {
  return COMBOX_SAMPLE_SENSOR_COLUMN_ORDER.filter((sensorIndex) => {
    const columnKey = getComBoxSampleSensorColumnKey(sensorIndex);
    const hasMeaningfulData = sampleRows.some((sampleRow) =>
      isMeaningfulSampleSensorValue(
        (sampleRow as Record<string, unknown>)[columnKey]
      )
    );

    return (
      hasMeaningfulData &&
      isConfiguredComBoxSampleSensor(sensorConfig?.[sensorIndex])
    );
  });
}
